import type { Color } from "@cloudnest/augmented-chess-engine";

interface GameResultBannerProps {
  result: "WHITE_WINS" | "BLACK_WINS" | "DRAW";
  reason?: string;
  playerColor?: Color;
}

function getBannerColor(
  result: "WHITE_WINS" | "BLACK_WINS" | "DRAW",
  playerColor?: Color,
): string {
  if (result === "DRAW") return "bg-yellow-500";

  if (!playerColor) {
    return result === "WHITE_WINS" ? "bg-green-600" : "bg-red-600";
  }

  const playerWins =
    (result === "WHITE_WINS" && playerColor === "WHITE") ||
    (result === "BLACK_WINS" && playerColor === "BLACK");

  return playerWins ? "bg-green-600" : "bg-red-600";
}

export function GameResultBanner({
  result,
  reason,
  playerColor,
}: GameResultBannerProps): JSX.Element {
  const bannerColor = getBannerColor(result, playerColor);

  return (
    <div
      data-testid="game-result"
      className={`mb-3 rounded-lg px-4 py-3 text-center font-semibold text-base text-white sm:mb-4 sm:px-8 sm:py-4 sm:text-lg ${bannerColor}`}
    >
      {result === "WHITE_WINS" && "\uBC31 \uC2B9\uB9AC!"}
      {result === "BLACK_WINS" && "\uD751 \uC2B9\uB9AC!"}
      {result === "DRAW" && "\uBB34\uC2B9\uBD80!"}
      {reason && <div className="mt-1 font-normal text-sm">({reason})</div>}
    </div>
  );
}
